import { registerComponent } from '@gig/magic-common';
import PasswordIndicatorComponent from './password-indicator.vue.js';

var PasswordIndicator = registerComponent(PasswordIndicatorComponent);

export { PasswordIndicator };
